import { CircularProgress } from '@mui/material'
import { ExternalSystemField, ExternalSystemFieldStatus } from 'shared/types'
import ExternalSystemFieldRow from './ExternalSystemFieldRow'
import {
  LoaderWrapper,
  ListWrapper,
  SelectedListWrapper,
  BasicListWrapper,
} from './ExternalSystemFieldsList.style'

interface ExternalSystemFieldsListProps {
  options: ExternalSystemField[]
  selectedOptions?: string[]
  onSave: (id: string, value: string) => void
  loading?: boolean
  disabled?: boolean
  onChangeValue?: (id: string, value: string) => void
  getFieldStatus?: (fieldId: string) => ExternalSystemFieldStatus
  onFieldCanSaveChange?: (fieldId: string, canSave: boolean) => void
  onFieldValidityChange?: (fieldId: string, isValid: boolean) => void
  control?: any
  errors?: any
  namePrefix?: string
}

const ExternalSystemFieldsList = ({
  options,
  selectedOptions: selectedOptionIds,
  onSave,
  loading,
  disabled,
  onChangeValue,
  getFieldStatus,
  onFieldCanSaveChange,
  onFieldValidityChange,
  control,
  errors,
  namePrefix,
}: ExternalSystemFieldsListProps) => {
  const selectedOptions =
    selectedOptionIds && selectedOptionIds.length
      ? options.filter(({ node: { id } }) => selectedOptionIds.includes(id))
      : []
  const notSelectedOptions =
    selectedOptionIds && selectedOptionIds.length
      ? options.filter(({ node: { id } }) => !selectedOptionIds.includes(id))
      : []

  return loading ? (
    <LoaderWrapper>
      <CircularProgress />
    </LoaderWrapper>
  ) : !selectedOptionIds || !selectedOptionIds.length ? (
    <BasicListWrapper>
      {options.map(option => (
        <ExternalSystemFieldRow
          {...option}
          onSave={onSave}
          disabled={disabled}
          onChangeValue={onChangeValue}
          fieldStatus={getFieldStatus?.(option.node.id)}
          onFieldCanSaveChange={onFieldCanSaveChange}
          onFieldValidityChange={onFieldValidityChange}
          key={option.node.id}
          control={control}
          error={errors?.[`${namePrefix || ''}${option.node.id}`]}
          name={`${namePrefix || ''}${option.node.id}`}
        />
      ))}
    </BasicListWrapper>
  ) : (
    <>
      <SelectedListWrapper>
        <ListWrapper>
          {selectedOptions.map(option => (
            <ExternalSystemFieldRow
              {...option}
              onSave={onSave}
              disabled={disabled}
              onChangeValue={onChangeValue}
              fieldStatus={getFieldStatus?.(option.node.id)}
              onFieldCanSaveChange={onFieldCanSaveChange}
              key={option.node.id}
              control={control}
              error={errors?.[`${namePrefix || ''}${option.node.id}`]}
              name={`${namePrefix || ''}${option.node.id}`}
            />
          ))}
        </ListWrapper>
      </SelectedListWrapper>
      <ListWrapper>
        {notSelectedOptions.map(option => (
          <ExternalSystemFieldRow
            {...option}
            onSave={onSave}
            disabled={disabled}
            onChangeValue={onChangeValue}
            fieldStatus={getFieldStatus?.(option.node.id)}
            onFieldCanSaveChange={onFieldCanSaveChange}
            key={option.node.id}
            control={control}
            error={errors?.[`${namePrefix || ''}${option.node.id}`]}
            name={`${namePrefix || ''}${option.node.id}`}
          />
        ))}
      </ListWrapper>
    </>
  )
}

export default ExternalSystemFieldsList
